<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp;View Details
    <div class="export_csv" mat-dialog-actions>
      <button
        stye="background-color: white !important;"
        class="clear_button_export rejbutt"
        style="float: left"
        (click)="onNoClick()"
        mat-raised-button
        color="primary"
      >
        Close
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-1"></div>
      <div class="profile_details">
        <mat-card class="page__content shadow p-3">
          <div
            class="imageList"
            style="float: right; margin-top: 12px; margin-right: 39px"
          ></div>
          <div class="details">
            <p><b>Ticket ID</b> : {{ ticketId }}</p>
            <!-- <p><b>Description</b> : {{ userComment }}</p> -->
            <p>
              <b>Image List</b> :
              <span *ngFor="let item of imageList">
                <img
                  *ngIf="item"
                  [src]="item"
                  spacebetween="10px"
                  width="100px"
                  height="100px"
                  style="margin: 0px 15px"
                />&emsp; </span
              >&emsp;
            </p>
            <p *ngFor="let item of records">
              <b>{{ item.createdBy }}</b> : {{ item.commentBody }}
            </p>
            <!-- <p><b>User Name</b> : {{userName}}</p>
              <p><b>User ID</b> : {{userID}}</p> -->

            <!-- <p><b>District</b> : {{district}}</p>
              <p><b>State</b> : {{state}}</p> -->
            <!-- <p><b>Mobile Number</b> : {{mobileNo}}</p>
              <p><b>SF User ID</b> : {{sfUserID}}</p>
              
              <p><b>Posted Date </b> : {{postedDate}}</p> -->
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
